<template>
  <div>
    <b-modal :title="title" v-model="showModal" @hide="$emit('close')" :size="modalSize" hide-footer>
      <slot>
      </slot>
    </b-modal>
  </div>
</template>

<script>
export default {
  data () {
    return {
      modalSize: 'xl'
    }
  },
  name: 'CustomModal',
  props: ['show', 'title'],
  computed: {
    showModal: {
      get: function () {
        return this.show
      },
      set: function () {}
    }
  }
}
</script>

<style scoped>

</style>
